<div class="container-fluid footer-container-wrapper">
    <div class="footer-container row ">
        
        <div class="footer-menu col-xl-9 col-lg-9 col-md-12 ">
            <div class="footer-menu col-xl-9 col-lg-9 col-md-12">
                <ul class="nav nav-pills">
                    <li>
                        <a target="_blank" 
                            [href]="'footer.aboutlink' | translate"
                            (click)="footerClick('about', footerLinks.aboutLink, footerLinks.aboutText)">
                            {{ 'footer.about' | translate }}
                        </a>
                    </li>
                    <li>
                        <a target="_blank" 
                            [href]="'footer.contactlink' | translate"
                            (click)="footerClick('contactUs', footerLinks.contactLink, footerLinks.contactText)">
                            {{ 'footer.contactUs' | translate }}
                        </a>
                    </li>
                    <li>
                        <a target="_blank" (click)="onNavClicked('feedback')">{{ 'footer.feedback' | translate}}</a>
                    </li>
                    <li>
                        <a target="_blank" 
                            [href]="'footer.policylink' | translate"
                            (click)="footerClick('policiesPermissions', footerLinks.policyLink, footerLinks.policyText)">
                            {{ 'footer.policyPermission' | translate }}
                        </a>
                    </li>
                    <li>
                        <a target="_blank" 
                            [href]="'footer.privacylink' | translate"
                            (click)="footerClick('privacyPolicy', footerLinks.privacyLink, footerLinks.privacyText)">
                            {{ 'footer.privacy' | translate }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer-logo-container col-xl-3 col-lg-3 d-xl-block d-lg-block d-none">
            <a target="_blank" href="https://www.pharmacists.ca/."><span class="footer-logo cpha-logo"></span></a>
        </div>
    </div>
    <div class="footer-container row justify-content-center">
        <div class="footer-copyright-div col-12 ">
            <span class="footer-copyright-span">{{'footer.cpha.copyright1' | translate}}, {{today | date:'y'}}. {{ 'footer.cpha.copyright2' | translate}}</span>
        </div>
    </div>
    <div class="footer-container row justify-content-center">
        <div class="footer-logo-container d-xl-none d-lg-none d-block col-12 d-sm-block">
            <span class="footer-logo cpha-logo"></span>
        </div>
    </div>
</div>
